import {Trans} from '@lingui/macro';
import {isEmpty} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {AtomItem, AtomItemGroups} from '../../editors/expressions/expressionAtomHelpers';
import {RuleExpressionsAtomPicker} from './ruleExpressionsAtomPicker';

/*
 * Types.
 */

export interface RuleExpressionAddBlockProps {
  groups: AtomItemGroups;
  onAddAtom: (atomItem: AtomItem, functionAtomClientId?: string) => void;
}

/*
 * Styles.
 */

const StyledWrapper = styled.div`
  margin-top: 4px;
  justify-self: flex-start;
`;

/*
 * Component.
 */

export const RuleExpressionAddBlock: FC<RuleExpressionAddBlockProps> = (props) => {
  const {groups, onAddAtom} = props;

  if (isEmpty(groups)) {
    return null;
  }

  return (
    <StyledWrapper>
      <RuleExpressionsAtomPicker groups={groups} onAddAtom={onAddAtom}>
        <Button variant={ButtonVariantsEnum.LINK}>
          <Trans id="rule-expressions-add-step">Add a step</Trans>
        </Button>
      </RuleExpressionsAtomPicker>
    </StyledWrapper>
  );
};
